exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flag-box[data-v-6dfefdc5] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.flag-box .flag-btn[data-v-6dfefdc5] {\n  margin-left: 10px;\n}\n.tips[data-v-6dfefdc5] {\n  padding: 0 0 2px 119px;\n  font-size: 10px;\n}\n", ""]);

// exports
